import {SoundUrlHelper} from '../../vendor/react-native-tapnovel-viewer';

export default SoundUrlHelper;
